import React from "react";

const NotFound = () => {
  return (
    <div className="container pt-3">
      <h1>404- Not Found</h1>
      <p className="lead">Aradığınız Sayfa Bulunamadı</p>
    </div>
  );
};

export default NotFound;
